export default [
  {
    path: "/",
    title: "dashboard",
    can: "all_CSOs",
    icon: "mdi-monitor-dashboard"
  },
  {
    path: "/reports",
    title: "filter_by",
    can: "all_reports",
    icon: "mdi-filter-variant"
  },
  {
    path: "/workshops",
    title: "workshops",
    can: "all_workshops",
    icon: "mdi-teach"
  },
  {
    model: false,
    title: "reports",
    group_icon: "mdi-chart-areaspline",
    children: [
      {
        path: "/reports/referral-report",
        title: "referral_report",
        icon: "mdi-finance",
        can: "all_reports"
      },
      {
        path: "/reports/analytical-status",
        title: "analytical_status",
        icon: "mdi-gradient",
        can: "all_reports"
      },
      {
        path: "/reports/analytical",
        title: "analytical_report",
        icon: "mdi-chart-bell-curve",
        can: "all_reports"
      },
      {
        path: "/reports/province",
        title: "provinces_report",
        icon: "mdi-map-legend",
        can: "all_reports"
      },
      {
        path: "/reports/program",
        title: "programs_report",
        icon: "mdi-chart-bubble",
        can: "all_reports"
      },
      {
        path: "/assessments-reports",
        title: "assessment_reports",
        can: "view_assessments",
        icon: "mdi-file-document-box-multiple-outline"
      },
      {
        path: "/re-assessments-reports",
        title: "re_assessment_reports",
        can: "view_assessments",
        icon: "mdi-file-check-outline"
      }
    ]
  },
  {
    icon: "settings",
    title: "settings",
    group_icon: "settings",
    model: false,
    children: [
      {
        title: "roles",
        path: "/roles",
        can: "all_roles",
        icon: "data_usage"
      },
      {
        title: "users",
        path: "/users",
        can: "all_users",
        icon: "mdi-account-multiple"
      },
      // {
      //   title: "backups",
      //   path: "/backups",
      //   can: "all_backups",
      //   icon: "mdi-cloud-upload"
      // },
      {
        icon: "mdi-card-text-outline",
        title: "questions",
        can: "all_questions",
        path: "/primary-data/questions"
      },
      {
        icon: "mdi-battlenet",
        can: "all_settings",
        title: "programs",
        path: "/primary-data/program"
      },
      {
        icon: "mdi-battlenet",
        can: "all_settings",
        title: "operational_areas",
        path: "/primary-data/province"
      }
    ]
  }
];
